import { SITE_ENGINEER_DETAILS } from "./type";

const initalState = {
  siteEngineerDetails: {},
};

const siteEngineerDetailsReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITE_ENGINEER_DETAILS:
      return {
        ...state,
        siteEngineerDetails: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default siteEngineerDetailsReducer;
